/**
 * Omnisend Dual Form Submission
 * Syncs Shopify notification form submissions with Omnisend embedded form
 */
(function() {
  'use strict';

  console.log('[Omnisend Sync] Script starting...');

  const OMNISEND_CONTAINER_ID = 'omnisend-embedded-v2-697d97a65d7d367eaba60f98';
  const OMNISEND_FORM_ID = 'omnisend-form-697d97a65d7d367eaba60f98-submit-form';
  const OMNISEND_EMAIL_ID = 'omnisend-form-697d97a65d7d367eaba60f98-field-container-62a3147776d81914aa87ed98-emailField-input';
  const OMNISEND_SUBMIT_ID = 'omnisend-form-697d97a65d7d367eaba60f98-action-627932485028ebd8c6660c51';
  const OMNISEND_SUCCESS_SELECTOR = '.omnisend-form-697d97a65d7d367eaba60f98-success-sections-container';

  let omnisendReady = false;
  let omnisendForm = null;
  let omnisendEmailInput = null;
  let omnisendSubmitBtn = null;

  /**
   * Check if Omnisend form elements are available
   */
  function checkOmnisendElements() {
    omnisendForm = document.getElementById(OMNISEND_FORM_ID);
    omnisendEmailInput = document.getElementById(OMNISEND_EMAIL_ID);
    omnisendSubmitBtn = document.getElementById(OMNISEND_SUBMIT_ID);

    const elementsFound = omnisendForm && omnisendEmailInput && omnisendSubmitBtn;
    
    // Update ready state if elements are found
    if (elementsFound && !omnisendReady) {
      omnisendReady = true;
      console.log('[Omnisend Sync] Omnisend form elements found');
    }
    
    return elementsFound;
  }

  /**
   * Set up MutationObserver to wait for Omnisend form to load
   */
  function waitForOmnisend() {
    // Check if already loaded
    if (checkOmnisendElements()) {
      omnisendReady = true;
      console.log('[Omnisend Sync] Omnisend form already loaded');
      return;
    }

    const container = document.getElementById(OMNISEND_CONTAINER_ID);
    if (!container) {
      console.warn('[Omnisend Sync] Omnisend container not found');
      return;
    }

    const omnisendObserver = new MutationObserver(function(mutations, obs) {
      if (checkOmnisendElements()) {
        omnisendReady = true;
        console.log('[Omnisend Sync] Omnisend form loaded');
        obs.disconnect();
      }
    });

    omnisendObserver.observe(container, {
      childList: true,
      subtree: true
    });

    // Fallback timeout - stop observing after 30 seconds
    setTimeout(function() {
      omnisendObserver.disconnect();
      if (!omnisendReady) {
        console.warn('[Omnisend Sync] Omnisend form did not load within timeout');
      }
    }, 30000);
  }

  /**
   * Wait for Omnisend form submission to complete (success state)
   */
  function waitForOmnisendSuccess() {
    return new Promise(function(resolve) {
      const successContainer = document.querySelector(OMNISEND_SUCCESS_SELECTOR);

      if (!successContainer) {
        // If no success container found, resolve after a short delay
        setTimeout(resolve, 1000);
        return;
      }

      // Check if already showing success
      if (successContainer.style.display !== 'none') {
        resolve();
        return;
      }

      const successObserver = new MutationObserver(function(mutations, obs) {
        if (successContainer.style.display !== 'none') {
          obs.disconnect();
          resolve();
        }
      });

      successObserver.observe(successContainer, {
        attributes: true,
        attributeFilter: ['style']
      });

      // Fallback timeout - resolve after 5 seconds regardless
      setTimeout(function() {
        successObserver.disconnect();
        resolve();
      }, 5000);
    });
  }

  /**
   * Set value on input in a way that React/framework-controlled inputs recognize
   */
  function setInputValue(input, value) {
    input.focus();

    var nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    );
    if (nativeInputValueSetter && nativeInputValueSetter.set) {
      nativeInputValueSetter.set.call(input, value);
    } else {
      input.value = value;
    }

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('blur', { bubbles: true }));
  }

  /**
   * Fill Omnisend form with email and submit
   */
  function submitOmnisendForm(email) {
    return new Promise(function(resolve) {
      // Check for elements fresh each time (form may have reloaded)
      if (!checkOmnisendElements()) {
        console.warn('[Omnisend Sync] Omnisend form elements not found');
        resolve();
        return;
      }

      // Use fresh references
      var emailInput = document.getElementById(OMNISEND_EMAIL_ID);
      var submitBtn = document.getElementById(OMNISEND_SUBMIT_ID);

      if (!emailInput || !submitBtn) {
        console.warn('[Omnisend Sync] Omnisend form elements not available');
        resolve();
        return;
      }

      // Fill email in a way Omnisend (React) recognizes
      setInputValue(emailInput, email);

      console.log('[Omnisend Sync] Email filled, clicking submit...');

      // Small delay so Omnisend validation/state can update, then click
      setTimeout(function() {
        submitBtn.focus();
        submitBtn.click();
      }, 100);

      // Wait for success
      waitForOmnisendSuccess().then(function() {
        console.log('[Omnisend Sync] Omnisend submission complete');
        resolve();
      });
    });
  }

  /**
   * Initialize Shopify notification form interception
   */
  function initNotificationFormInterception() {
    // Find all notification forms using event delegation
    document.addEventListener('submit', function(event) {
      const form = event.target;

      // Check if this is a notification form
      if (!form.hasAttribute('data-notification-form')) {
        return;
      }

      // Check for Omnisend elements fresh each time (form may have reloaded)
      if (!checkOmnisendElements()) {
        console.log('[Omnisend Sync] Omnisend form elements not found, submitting Shopify form only');
        return;
      }

      // Get email from Shopify form
      const emailInput = form.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.value) {
        console.log('[Omnisend Sync] No email found in Shopify form');
        return;
      }

      const email = emailInput.value;

      // На странице товара сабмит ведёт snippets/preorder-webhook.liquid:
      // заявка уходит в Odoo, письма на /contact нет. Здесь только подписываем
      // email в Omnisend. Форму не трогаем и нативно не отправляем — иначе
      // письмо на почту магазина уйдёт снова.
      if (window.__pvPreorderHooked) {
        submitOmnisendForm(email);
        return;
      }

      // Prevent default form submission
      event.preventDefault();
      event.stopPropagation();

      console.log('[Omnisend Sync] Intercepted notification form, submitting to Omnisend first...');

      // Submit to Omnisend first, then submit Shopify form
      submitOmnisendForm(email).then(function() {
        console.log('[Omnisend Sync] Omnisend done, now submitting Shopify form');

        // Create a hidden input to track that we've already processed this
        const processedInput = document.createElement('input');
        processedInput.type = 'hidden';
        processedInput.name = '_omnisend_processed';
        processedInput.value = '1';
        form.appendChild(processedInput);

        // Submit Shopify form natively
        form.submit();
      });
    }, true); // Use capture phase
  }

  // Initialize Omnisend integration
  function init() {
    console.log('[Omnisend Sync] Initializing...');
    waitForOmnisend();
    initNotificationFormInterception();
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
